import React, { useEffect } from 'react';
import { CommentIcon, ReplyIcon, MessageIcon, UserIcon, HeartIcon, MentionIcon } from '../ui/IconComponents';
import './Toast.css';

const Toast = ({ notification, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  const getIcon = (type) => {
    switch (type) {
      case 'NEW_MESSAGE':
        return <MessageIcon className="w-5 h-5" />;
      case 'NEW_FOLLOWER':
        return <UserIcon className="w-5 h-5" />;
      case 'LIKED':
        return <HeartIcon className="w-5 h-5" isFilled={true} />;
      case 'COMMENTED':
        return <CommentIcon className="w-5 h-5" />;
      case 'MENTIONED':
        return <MentionIcon className="w-5 h-5" />;
      case 'COMMENT_REPLY':
        return <ReplyIcon className="w-5 h-5" />;
      case 'COMMENT_MENTION':
        return <MentionIcon className="w-5 h-5" />; // ✅ NEW
      default:
        return '🔔';
    }
  };

  const getColor = (type) => {
    switch (type) {
      case 'NEW_MESSAGE':
        return 'bg-blue-500';
      case 'NEW_FOLLOWER':
        return 'bg-purple-500';
      case 'LIKED':
        return 'bg-red-500';
      case 'COMMENTED':
        return 'bg-green-500';
      case 'MENTIONED':
        return 'bg-yellow-500';
      case 'COMMENT_REPLY':
        return 'bg-indigo-500';
      case 'COMMENT_MENTION':
        return 'bg-orange-500'; // ✅ NEW
      default:
        return 'bg-gray-600';
    }
  };

  return (
    <div className={`toast ${getColor(notification.type)} toast-enter`}>
      <div className="toast-content">
        <span className="toast-icon">{getIcon(notification.type)}</span>
        <div className="toast-text">
          <h4 className="toast-title">{notification.title}</h4>
          <p className="toast-message">{notification.message}</p>
        </div>
      </div>
      <button className="toast-close" onClick={onClose}>×</button>
    </div>
  );
};

export default Toast;


